<template>
  <BasicModal
    :title="'回答内容・送付履歴リスト'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <!-- モーダル：会話履歴・送付履歴 -->
    <ModalDownloadTalkHistory @getChatBots="getChatBots" ref="talkDownload"/>
    <b-modal width="680px" :active.sync="isShowBilling">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            従量課金プラン - 上限超過
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              現在従量課金プランの上限を超過している関係上、<br>
              会話内容を閲覧することができません。<br>
              下記ボタンより、上限設定の変更をお願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBilling=false">閉じる</a>
          <a class="card-footer-item" @click="$router.push('/client/setting/billing')">上限設定変更画面へ</a>
        </footer>
      </div>
    </b-modal>
    <div style="padding: 8px;">
      <b-tabs type="is-boxed">
        <b-tab-item label="回答内容">
          <div style="padding: 8px; height: 580px;">
            <div style="text-align: left; margin-bottom: 16px;">
              <button class="button" @click="downloadDialog([chatbot])">会話履歴ダウンロード</button>
            </div>
            <div :class="{'display-none': botNameClick}" style="text-align: left">
              <article>
                <h3 style="font-weight: bold; margin-bottom: 16px; border-bottom: 1px solid #dbdbdb; padding-bottom: 8px;">メインロボ</h3>
                <template v-if="!chatbotLoading">
                  <div style="margin-top: 8px; margin-left: 16px;">
                    <p @click="mainBotActionTable(chatbot)" class="bot-name" style="font-size: 14px; cursor: pointer; width: fit-content">{{chatbot.name}}</p>
                  </div>
                </template>
                <template v-else>
                  <div style="margin-top: 8px; margin-left: 16px;">
                    <p><span class="mdi mdi-loading mdi-spin" style="font-size: 14px;"></span></p>
                  </div>
                </template>
              </article>
              <article style="margin-top: 32px" v-if="chatbot.chatbot_mini.length > 0">
                <h3 style="font-weight: bold; margin-bottom: 16px; border-bottom: 1px solid #dbdbdb; padding-bottom: 8px;">ミニロボ一覧</h3>
                <div class="mini-bots-wrapper disp-scroll">
                  <template v-if="!chatbotLoading">
                    <div style="margin-top: 8px; margin-left: 16px;" v-for="(mini, index) in chatbot.chatbot_mini" :key="index">
                      <p @click="miniBotActionTable(mini)" class="bot-name" style="font-size: 14px; cursor: pointer">{{mini.name}}</p>
                    </div>
                  </template>
                  <template  v-else>
                    <div style="margin-top: 8px; margin-left: 16px;">
                      <p><span class="mdi mdi-loading mdi-spin" style="font-size: 14px;"></span></p>
                    </div>
                  </template>
                </div>
              </article>
            </div>
            <div :class="{'display-none': !botNameClick}" style="text-align: left; font-size: 12px;">
              <div @click="resetSeekerrSortedInfosState()"><i class="mdi mdi-arrow-left" style="font-size: 24px; cursor: pointer"></i></div>
              <div style="font-size: 14px;">{{selectBotName}}</div>
              <div class="list-container disp-scroll">
                <p v-if="seekerIds.length === 0" style="font-size: 14px; color: rgb(187, 187, 187)">まだ回答者がいません。</p>
                <div v-for="(seekerId, i) in seekerIds" :key="i" class="line disp-scroll">
                  <template v-for="seekerItem in seekerItems">
                    <div :key="seekerItem.seekerId" class="seeker-item" v-if="seekerItem.seekerId == seekerId" style="background-color: #fff; padding: 8px; border-right: 1px transparent solid; margin-right: -1px; position: -webkit-sticky; position: sticky; left: 0;">
                      <div style="width: 200px;" v-if="user.billing === 3
                          && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                          && seekerItem.latestDate >= payperuseInfoData.overflow_date">
                        <p style="font-size: 14px;">訪問者●●●</p>
                        <p style="margin-top: 8px; font-size: 12px; color: #666;">
                          課金された料金の上限を超えております。
                          上限を超えた日時以降のメッセージは見ることができません。
                        </p>
                      </div>
                      <div style="width: 200px;" v-else>
                        <p style="font-size: 14px;"><i class="mdi mdi-account" style="margin-right: 4px"></i>{{seekerItem.seekerName}}</p>
                        <p style="margin-top: 8px; font-size: 10px;">最終日時:{{new Date(seekerItem.latestDate).toLocaleString()}}</p>
                        <p style="margin-top: 16px;">GOAL通過:
                            <span v-if="seekerItem.isCv" style="color: red; font-weight: bold;">○</span>
                            <span v-else style="color: blue; font-weight: bold;">×</span>
                        </p>
                      </div>
                    </div>
                  </template>
                  <div v-for="(seekerSortedInfo, j) in seekerSortedInfos[seekerId]" :key="`X_${j}}`" style="background-color: #fff; display: flex;">
                    <div @click="isShowBilling = true" v-if="user.billing === 3
                        && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                        && seekerSortedInfo.created_at >= payperuseInfoData.overflow_date">
                      <p class="item-box">
                        本メッセージは見ることができません。<br>
                        クリックで上限設定の見直しをお願いします。
                      </p>
                    </div>
                    <div v-else>
                      <div class="item-box">
                        <div style="display: flex">
                          <p style="padding-right: 4px;"><span style="color: blue;">Q</span>:</p>
                          <p>{{alterReplace(seekerSortedInfo.cb_msg, true)}}</p>
                        </div>
                        <div style="display: flex; margin-top: 8px;">
                          <p style="padding-right: 4px"><span style="color: red;">A</span>:</p>
                          <p style="font-weight: bold;">{{alterReplace(seekerSortedInfo.seeker_msg, true)}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="送付履歴(一括)">
          <div class="basic-modal-content table-wrapper">
            <!-- テーブル一覧 -->
            <EmailLogTable v-if="botEmailList.length"
              :sendedEmailList="botEmailList"
              @clickEmailDetailButton="clickBotDetailButton"/>
            <div v-else class="nothing-email-message">
              <p>まだこのロボからはEメールを送付しておりません。</p>
            </div>
            <!-- メール詳細 -->
            <EmailDetail v-if="isDetailedBotEmail"
              :selectSended="selectedBotEmail"
              :enablePrev="botEmailDetailStatus.enablePrev"
              :enableNext="botEmailDetailStatus.enableNext"
              @clickPrev="clickBotPrev"
              @clickNext="clickBotNext"
              @clickCloseBtn="clickBotCloseButton"/>
          </div>
        </b-tab-item>
        <b-tab-item label="送付履歴(シナリオパーツ)">
          <div class="basic-modal-content table-wrapper">
            <!-- テーブル一覧 -->
            <EmailLogTable v-if="scenarioEmailList.length"
              :sendedEmailList="scenarioEmailList"
              @clickEmailDetailButton="clickScenarioDetailButton"/>
            <div v-else class="nothing-email-message">
              <p>まだこのロボからはEメールを送付しておりません。</p>
            </div>
            <!-- メール詳細 -->
            <EmailDetail v-if="isDetailedScenarioEmail"
              :selectSended="selectedScenarioEmail"
              :enablePrev="scenarioEmailDetailStatus.enablePrev"
              :enableNext="scenarioEmailDetailStatus.enableNext"
              @clickPrev="clickScenarioPrev"
              @clickNext="clickScenarioNext"
              @clickCloseBtn="clickScenarioCloseButton"/>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
     <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">閉じる</button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import alterReplace from '@/functions/alterStrReplace'
import ModalDownloadTalkHistory from '@/components/ui/ModalDownloadTalkHistory'
import EmailLogTable from '@/components/molecules/tables/EmailLogTable'
import EmailDetail from '@/components/organisms/articles/EmailDetail'
export default {
  components: {
    BasicModal,
    ModalDownloadTalkHistory,
    EmailLogTable,
    EmailDetail
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('auth', ['payperuseInfoData', 'user']),
    ...mapState('directtalk', ['csvFile'])
  },
  created () {
    this.resetSeekerrSortedInfosState()
    this.chatbotLoading = true
    this.$store.dispatch('directtalk/fetchSeekerInputInfo', this.chatbot)
      .then((d) => {
        this.seekerInputInfos = d
        this.chatbotLoading = false
      })
  },
  data () {
    return {
      // 回答履歴
      botNameClick: false,
      seekerIds: [],
      seekerSortedInfos: {},
      selectBotName: '',
      seekerItems: [],
      seekerInputInfos : [],
      chatbotLoading: false,
      // 送付履歴@一括
      botEmailList: [],
      isDetailedBotEmail: false,
      selectedBotEmail: undefined,
      // 送付履歴@シナリオ
      scenarioEmailList: [],
      isDetailedScenarioEmail: false,
      selectedScenarioEmail: undefined,
      isShowBilling: false,
      bots: [],
      botEmailDetailStatus: {enablePrev: true, enableNext: false},
      scenarioEmailDetailStatus: {enablePrev: true, enableNext: false}
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile != null) {
        // ミニロボの台数
        let cnt = this.bots[0]["chatbot_mini"].length

        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var blob = new Blob([bom, this.csvFile], { "type" : "text/csv" })
        var downLoadLink = document.createElement('a')
        if (cnt == 0) {
          downLoadLink.download = this.bots[0]["name"] + '.csv'
        } else {
          downLoadLink.download = this.bots[0]["name"] + '（ミニロボ台数 ' + String(cnt) + '）.csv'
        }
        downLoadLink.href = URL.createObjectURL(blob)
        downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
        downLoadLink.click()
      }
    },
    isShowModal () {
      if (this.isShowModal) {
        this.getSendedBotEmailList()
        this.getSendedScenarioEmailList()
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    downloadDialog (chatbot) {
      this.$refs.talkDownload.bots = chatbot
      this.$refs.talkDownload.isCardModalActive = true
    },
    alterReplace (msg, dir) {
      return alterReplace(msg, dir)
    },
    mainBotActionTable (chatbot) {
      this.selectBotName = chatbot.name
      this.botNameClick = true
      // TODO: サーバーサイドでデータを成形した方が楽そう
      // seekerを全員列挙
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (this.seekerIds.indexOf(seekerInputInfo.seeker_id) === -1 && seekerInputInfo.cb_type === "main") {
          this.seekerIds.push(seekerInputInfo.seeker_id)
          this.seekerSortedInfos[seekerInputInfo.seeker_id] = []
        }
      }
      // seekerごとに入力情報を持たせる
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (seekerInputInfo.cb_type === "main") {
          this.seekerSortedInfos[seekerInputInfo.seeker_id].push(seekerInputInfo)
        }
      }
      this.sortSeekerItems()
    },
    miniBotActionTable (mini) {
      this.selectBotName = mini.name
      this.botNameClick = true
      // seekerを全員列挙
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (this.seekerIds.indexOf(seekerInputInfo.seeker_id) === -1 && seekerInputInfo.cbmini_id === mini.bot_id) {
          this.seekerIds.push(seekerInputInfo.seeker_id)
          this.seekerSortedInfos[seekerInputInfo.seeker_id] = []
        }
      }
      // seekerごとに入力情報を持たせる
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (seekerInputInfo.cbmini_id === mini.bot_id) {
          this.seekerSortedInfos[seekerInputInfo.seeker_id].push(seekerInputInfo)
        }
      }
      this.sortSeekerItems()
    },
    sortSeekerItems () {
      for (let i in this.seekerIds) {
        let seekerName = ''
        let date = ''
        let isCv = ''
        for (let j in this.seekerSortedInfos[this.seekerIds[i]]) {
          seekerName = this.seekerSortedInfos[this.seekerIds[i]][j].seeker_name
          date = this.seekerSortedInfos[this.seekerIds[i]][j].created_at
          isCv = this.seekerSortedInfos[this.seekerIds[i]][j].is_cv
        }
        this.seekerItems.push(
          {seekerId: this.seekerIds[i], seekerName: seekerName, latestDate: date, isCv: isCv}
        )
      }
    },
    resetSeekerrSortedInfosState () {
      this.botNameClick = false
      this.seekerIds = []
      this.seekerSortedInfos = {}
      this.selectBotName = ''
      this.seekerItems = []
    },
    getSendedBotEmailList () {
      this.$store.dispatch("directtalk/getSendedBotEmailList", this.chatbot.bot_id)
        .then((data) => {
          this.botEmailList = data
        })
    },
    getSendedScenarioEmailList () {
      this.$store.dispatch("directtalk/getSendedScenarioEmailList", this.chatbot.bot_id)
        .then((data) => {
          this.scenarioEmailList = data
          // 宛先が訪問者ではない場合もあるため
          this.scenarioEmailList = this.scenarioEmailList.map(item => {item['name'] = item['to_email']; return item;})
        })
    },
    selectBotEmailDetailIndex (idx) {
      if (idx < 0 || idx >= this.botEmailList.length) return
      this.selectedBotEmail = this.botEmailList[idx]
      this.botEmailDetailStatus.enableNext = (idx != 0)
      this.botEmailDetailStatus.enablePrev = (idx != this.botEmailList.length-1)
    },
    clickBotDetailButton (select) {
      this.isDetailedBotEmail = true
      const idx = this.botEmailList.findIndex((item) => item == select)
      this.selectBotEmailDetailIndex(idx)
    },
    clickBotNext() {
      const idx = this.botEmailList.findIndex((item) => item == this.selectedBotEmail)
      this.selectBotEmailDetailIndex(idx-1)
    },
    clickBotPrev() {
      const idx = this.botEmailList.findIndex((item) => item == this.selectedBotEmail)
      this.selectBotEmailDetailIndex(idx+1)
    },
    clickBotCloseButton () {
      this.isDetailedBotEmail = false
    },
    selectScenarioEmailDetailIndex (idx) {
      if (idx < 0 || idx >= this.scenarioEmailList.length) return
      this.selectedScenarioEmail = this.scenarioEmailList[idx]
      this.scenarioEmailDetailStatus.enableNext = (idx != 0)
      this.scenarioEmailDetailStatus.enablePrev = (idx != this.scenarioEmailList.length-1)
    },
    clickScenarioDetailButton (select) {
      this.isDetailedScenarioEmail = true
      const idx = this.scenarioEmailList.findIndex((item) => item == select)
      this.selectScenarioEmailDetailIndex(idx)
    },
    clickScenarioNext() {
      const idx = this.scenarioEmailList.findIndex((item) => item == this.selectedScenarioEmail)
      this.selectScenarioEmailDetailIndex(idx-1)
    },
    clickScenarioPrev() {
      const idx = this.scenarioEmailList.findIndex((item) => item == this.selectedScenarioEmail)
      this.selectScenarioEmailDetailIndex(idx+1)
    },
    clickScenarioCloseButton () {
      this.isDetailedScenarioEmail = false
    },
    getChatBots (bots) {
      this.bots = bots
    }
  }
}
</script>

<style lang="scss" scoped>
.display-none {
  display: none;
}
.bot-name:hover {
  color:#EE2C98;
}
.mini-bots-wrapper {
  height: 240px;
}
.seeker-item::before{
  content : "" ;
  position : absolute ;
  top : 0 ;
  left : 0 ;
  width : 100% ;
  height : 100% ;
  border: solid 1px #dbdbdb;
}
.item-box {
  width: 200px;
  height: 100%;
  border: 1px solid #dbdbdb;
  padding: 8px;
  border-right: 1px transparent solid;
  margin-right: -1px;
}
.item-box:last-child {
  border-right: 1px solid #dbdbdb;
}
.line {
  display: flex;
}
.list-container {
  height: 280px;
  margin-top: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}

.basic-modal-content {
  padding: 8px;
  height: 580px;
  text-align: center;
  overflow: hidden;
  .description {
    text-align: left;
    p {
      font-size: 12px;
    }
  }
  .buttons-wrapper {
    margin-top: 24px;
    .selected {
      background: rgb(221, 221, 221);
    }
  }
  .setting-area {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-date {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .setting-area-date {
    span {
      margin-left: 4px;
    }
  }
  .desc {
    text-align: left;
    font-size: 12px;
    margin-bottom: 4px;
  }
  .input-wrapper {
    display: flex;
    button {
      margin-left: 4px;
    }
  }
  .sendlist-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 8px;
  }
  .sub-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: bold;
  }
  .email-list {
    text-align: left;
    padding-top: 24px;
    .item-list {
      height: 304px;
      padding-right: 8px;
      //overflow-y: auto;
    }
    .item-list::-webkit-scrollbar {
      //width: 5px;
    }
    .item {
      button {
        margin-left: 4px;
      }
    }
    :not(:first-child).item {
      margin-top: 8px;
    }
    .email-list-table {
      font-size: 12px;
      position: relative;
      .table-header {
        position: sticky;
        top: 0;
        background: #ffffff;
        z-index: 10;
        ul {
          display: flex;
          align-items: center;
          border: 1px solid gray;
        }
      }
      .table-content {
        margin-top: 8px;
        ul {
          display: flex;
        }
      }
    }
    $email-width: 320px;
    $checkbox-width: 80px;
    .email {
      width: $email-width;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 4px;
    }
    $cell-padding: 4px;
    .header-email {
      width: $email-width;
      padding: 4px;
    }
    .header-robo-email {
      width: $checkbox-width;
      padding: $cell-padding;
    }
    .header-talk-log-email {
      width: $checkbox-width;
      padding: $cell-padding;
    }
    .header-delete {
      width: 120px;
    }
    .robo-email, .talk-log-email {
      display: flex;
      justify-content: center;
      align-items: center;
      width: $checkbox-width - $cell-padding;
      font-size: 16px;
      padding: $cell-padding;
      padding-left: 16px;
    }
    .delete-button-wrapper {
      margin-left: 40px;
    }
  }
  .periods-list {
    margin-top: 24px;
  }
  .item-period-container {
    height: 160px;
    overflow: auto;
    padding-right: 8px;
  }
  .item-period-container::-webkit-scrollbar {
    width: 5px;
  }
  .item-period-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 0;
    p {
      font-size: 12px;
      text-align: left;
      width: 200px;
    }
  }
  :not(:last-child).item-period-wrapper {
    border-bottom: 1px solid #dbdbdb;
  }
  .mail-content {
    margin-top: 24px;
  }
  .mail-content-desc {
    margin-top: 8px;
    text-align: left;
    p {
      font-size: 12px;
    }
  }
  .date-list {
    li {
      text-align: left;
      width: 100%;
      padding: 4px;
      border: 1px solid gray;
    }
    :not(:first-child) {
      border-top: none;
    }
  }
  .nothing-email-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.table-wrapper {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailConvResult.vue